export interface Route {
    id: string;
    url: string;
    label: string;
    newTab: boolean;
}
export interface Redirect {
    sourceUrl: string | null;
    targetUrl: string | null;
    type: string | null;
}

export type RedirectProps = {
    redirects?: Redirect[];
};
export type HeaderNavigationProps = {
    mainItems: Array<Route> | null;
    hamburgerItems: Array<Route> | null;
};

export type FooterNavigationProps = {
    featuredItems: Array<Route> | null;
    unfeaturedItems: Array<Route> | null;
};

export type NavigationProps = HeaderNavigationProps & FooterNavigationProps & RedirectProps;

export enum NavigationVariant {
    Main = 'main',
    Hamburger = 'hamburger',
    Featured = 'featured',
    Unfeatured = 'unfeatured',
}
